import classnames from 'classnames/bind'
import Image from '@/components/common/Image'
import { isEmpty } from 'lodash-es'
import { useAppSelector } from '@/redux/hooks'

// Components
import Link from '@/components/common/Link'

// Constants
import { EXTERNAL_LINK } from '@/constants/externalLink'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

function SimpleHeader() {
  const memberData = useAppSelector((state) => state?.member?.memberData)

  return (
    <header className={cx('header')}>
      <div className={cx('header__wrapper')}>
        <Link url={EXTERNAL_LINK.KIYAAN_JEWELLERY_INSTAGRAM} isOpen>
          <div className={cx('header-logo')}>
            <Image src='/images/kiyaan-jewellery-logo.png' width={555} height={555} alt='Kiyaan Jewels' />
          </div>
        </Link>
        <div className={cx('header__right')}>
          {!isEmpty(memberData.refCode) && <div className={cx('header__code')}>ID: {memberData.refCode}</div>}
          <div className={cx('header__actions')}>
            <a
              className={cx('header__action')}
              href={EXTERNAL_LINK.KIYAAN_JEWELLERY_INSTAGRAM}
              target='_blank'
              rel='noopener noreferrer'
              aria-label='Instagram'
            >
              <span className={cx('header__action-icon')}>
                <Image src='/images/kiyaan-jewellery-instagram.png' width={24} height={24} alt='' />
              </span>
            </a>
            <a
              className={cx('header__action')}
              href={EXTERNAL_LINK.KIYAAN_JEWELLERY_LINKEDIN}
              target='_blank'
              rel='noopener noreferrer'
              aria-label='LinkedIn'
            >
              <span className={cx('header__action-icon')}>
                <Image src='/images/kiyaan-jewellery-linkedin.png' width={24} height={24} alt='' />
              </span>
            </a>
          </div>
        </div>
      </div>
    </header>
  )
}

export default SimpleHeader
